import CreateSellpoint from '@/pages/CreateSellpoint'

export default {
  path: '/create',
  name: 'CreateSellpoint',
  component: CreateSellpoint,
  
}



// WEBPACK FOOTER //
// ./src/router/createsellpoint.js